import { FormattedMessage } from 'react-intl';

import './ExperimentalLabel.sass';

const ExperimentalLabel = ({ mini = false }: { mini?: boolean }) => {
	return (
		<div id="experimental-label" className={`${mini ? 'mini' : ''}`}>
			<h1>
				<FormattedMessage id="experimental-label.title" />
			</h1>
			{!mini && (
				<p>
					<FormattedMessage id="experimental-label.text" />
				</p>
			)}
		</div>
	);
};

export default ExperimentalLabel;
